<div class="card panel-flat-color secondary-panel">
    <div class="panel-flat-header" style="display: flex; justify-content: space-between">
        <h3>Assessment Classes</h3>
        <div class="header-button-container">
            @if (hasEditPermission && !assessor) {
                <button
                    class="ace-btn btn-text has-icon btn-primary"
                    (click)="launchClassModal()"
                    [disabled]="serverAction"
                >
                    <i class="fa fa-plus-circle"></i>
                </button>
            }
        </div>
    </div>
    <div class="panel-flat-body">
        <ws-ace-loader [show]="serverAction" [size]="4" [hasOverlay]="true"></ws-ace-loader>
        <table class="table table-hover">
            <thead>
                <tr>
                    <th>Assessment Classification</th>
                    <th>Parcel Prop Types</th>
                    <th>Component(s)</th>
                    <th>Ratio</th>
                    <th>Notes</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                @for (ac of assessmentClasses; track ac) {
                    @if (ac.isVisible) {
                        <tr (mouseenter)="ac.isHovered = true" (mouseleave)="ac.isHovered = false">
                            <td>{{ ac.name }}</td>
                            <td>
                                @for (propType of ac.propTypes; track propType) {
                                    <div>{{ propType.abbr }}</div>
                                }
                            </td>
                            <td>
                                @for (propType of ac.propTypes; track propType) {
                                    <div>{{ propType.componentsString }}</div>
                                }
                            </td>
                            <td>
                                @if (ac.ratioSetAtAssessor && !assessor) {
                                    <div>Defined at Assessor</div>
                                }
                                @if (!(ac.ratioSetAtAssessor && !assessor)) {
                                    <div>
                                        @if (ac.fixedRatio) {
                                            <div>
                                                @for (
                                                    ratio of ac.assessmentClassRatios;
                                                    track ratio;
                                                    let first = $first
                                                ) {
                                                    <span>
                                                        @if (first) {
                                                            <span>{{ ratio.assessmentRatio | percent: '1.0-3' }}</span>
                                                        }
                                                    </span>
                                                }
                                            </div>
                                        }
                                        @if (!ac.fixedRatio) {
                                            <div>
                                                @for (
                                                    ratio of ac.assessmentClassRatios;
                                                    track ratio;
                                                    let last = $last
                                                ) {
                                                    <span>
                                                        {{ ratio.taxYear }}:
                                                        {{ ratio.assessmentRatio | percent: '1.0-3' }}
                                                        @if (!last) {
                                                            <span>,</span>
                                                        }
                                                    </span>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                            </td>
                            <td>
                                @if (ac.description) {
                                    <i
                                        class="fa fa-file-text"
                                        [popover]="ac.description"
                                        [adaptivePosition]="false"
                                        container="body"
                                        triggers="mouseenter:mouseleave"
                                    ></i>
                                }
                            </td>
                            <td>
                                @if (hasEditPermission) {
                                    <div class="ws-button-row" [class.invisible]="!ac.isHovered">
                                        <button class="ace-btn has-icon btn-primary m-0" (click)="launchClassModal(ac)">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button class="ace-btn has-icon btn-primary btn-danger" style="margin: 0">
                                            <i class="fa fa-trash" (click)="deleteClass(ac)"></i>
                                        </button>
                                    </div>
                                }
                            </td>
                        </tr>
                    }
                }
            </tbody>
        </table>
        @if (assessor) {
            <div class="checkbox">
                <label>
                    <input type="checkbox" [(ngModel)]="showStateClasses" (ngModelChange)="onShowUnusedChanged()" />
                    Show unused state assessment classification(s)
                </label>
            </div>
        }
    </div>
</div>
